// routes.js
import Home from "./Home";
import About from "./About";
import Login from "./Login";
import Register from "./pages/Register";
import Menu from "./pages/MainTab";
import EditMenu from "./pages/EditMenu";
import AddMenu from "./pages/AddMenu";
import AddMenuPopUp from "./pages/AddMenuPopUp";
import OTP from "./pages/OtpVerification";
import ForgetPassword from "./pages/ForgetPassword";
import OtpForget from "./pages/OtpForget";
import NewPassword from "./pages/NewPassword";
import MainTab from "./pages/MainTab";
import ProfileEdit from "./pages/ProfileEdit";
import RestaurantEdit from "./pages/RestaurantEdit";
import PageCart from "./pages/Cart";
import PageOrdersDetails from "./pages/OrdersDetails";
import PageBidDetails from "./pages/BidDetails";
import PageInvoice from "./pages/Invoice";
import SearchMenu from "./pages/SearchMenu";
import SettingEdit from "./pages/SettingEdit";
import WalletEdit from "./pages/WalletEdit";
import Orders from "./pages/Orders";
import notification from "./pages/Notification";
import PageCardAdd from "./pages/CardAdd";
import PageEventDetail from "./pages/EventDetail";
import PageOrderDetail from "./pages/OrderDetails";
import PageOrderView from "./pages/OrderView";
import PageAddEvent from "./pages/AddEvent";
import PagePayment from "./pages/Payment";
import PageConfirmBid from "./pages/ConfirmBid";
import PageAbout from "./pages/About";
import PageHelp from "./pages/Help";
import OrdersCanListPage from "./pages/OrdersCanList";
import PageCanOrderDetails from "./pages/CanOrderDetails";
// import Bids from "./pages/Bids";
// import Orders from "./pages/Orders";
// import Profile from "./pages/Profile";
import PagePaymentSuccess from "./pages/PaymentSuccess";
import PageOrderSearch from "./pages/SearchOrderPage";
import PayInvoicePage from "./pages/PayInvoice";
import EditOrderPage from "./pages/EditOrder";
import Page404 from "./404";
import ExpiredOrderListPage from "./pages/ExpiredOrderList";
import PageExpiredOrderDetailsPage from "./pages/ExpiredOrderDetails";
import DirectOrders from "./pages/DirectOrderList";

const routes = [
  {
    path: "/",
    component: Home,
    options: {
      force: true,
    },
  },
  {
    path: "/about/",
    component: About,
    options: {
      force: true,
    },
  },
  {
    path: "/login/",
    component: Login,
    options: {
      force: true,
    },
  },
  {
    path: "/otpverify/",
    component: OTP,
    options: {
      force: true,
    },
  },
  {
    path: "/register/",
    component: Register,
    options: {
      force: true,
    },
  },
  {
    path: "/forgetpassword/",
    component: ForgetPassword,
    options: {
      force: true,
    },
  },
  {
    path: "/otpforget/",
    component: OtpForget,
    options: {
      force: true,
    },
  },
  {
    path: "/newpassword/",
    component: NewPassword,
    options: {
      force: true,
    },
  },
  {
    name: "main",
    path: "/main/",
    component: MainTab,
    options: {
      force: true,
    },
  },
  {
    name: "menu",
    path: "/menu/",
    component: Menu,
    options: {
      force: true,
    },
  },
  {
    path: "/addmenu/",
    component: AddMenu,
    options: {
      force: true,
    },
  },
  {
    path: "/searchmenu/",
    component: SearchMenu,
    options: {
      force: true,
    },
  },
  {
    path: "/editmenu/:id",
    component: EditMenu,
    options: {
      force: true,
    },
  },
  {
    path: "/profileedit/",
    component: ProfileEdit,
    options: {
      force: true,
    },
  },
  {
    path: "/restaurantedit/",
    component: RestaurantEdit,
    options: {
      force: true,
    },
  },
  {
    path: "/cart/",
    component: PageCart,
    options: {
      force: true,
    },
  },
  {
    path: "/orderdetails/",
    component: PageOrdersDetails,
    options: {
      force: true,
    },
  },
  {
    path: "/eventdetail/:eid/:os",
    component: PageEventDetail,
    options: {
      force: true,
    },
  },
  {
    path: "/biddetails/",
    component: PageBidDetails,
    options: {
      force: true,
    },
  },
  {
    path: "/invoice/",
    component: PageInvoice,
    options: {
      force: true,
    },
  },
  {
    path: "/setting/",
    component: SettingEdit,
    options: {
      force: true,
    },
  },
  {
    path: "/wallet/",
    component: WalletEdit,
    options: {
      force: true,
    },
  },
  {
    path: "/cardadd/",
    component: PageCardAdd,
    options: {
      force: true,
    },
  },
  {
    path: "/orders/",
    component: Orders,
    options: {
      force: true,
    },
  },
  {
    path: "/directorders/",
    component: DirectOrders,
    options: {
      force: true,
    },
  },
  {
    path: "/addevent/",
    component: PageAddEvent,
    options: {
      force: true,
    },
  },
  {
    path: "/order_details/:eid",
    component: PageOrderDetail,
    options: {
      force: true,
    },
  },
  {
    path: "/orderview/:id",
    component: PageOrderView,
    options: {
      force: true,
    },
  },
  {
    path: "/notification/",
    component: notification,
    options: {
      force: true,
    },
  },
  {
    path: "/restabout/",
    component: PageAbout,
    options: {
      force: true,
    },
  },
  {
    path: "/help/",
    component: PageHelp,
    options: {
      force: true,
    },
  },
  {
    name: "payment",
    path: "/payment/:id",
    component: PagePayment,
    options: {
      force: true,
    },
  },
  {
    name: "confirmbid",
    path: "/confirmbid/:date",
    component: PageConfirmBid,
    options: {
      force: true,
    },
  },
  {
    path: "/payment-success/",
    component: PagePaymentSuccess,
    options: {
      force: true,
    },
  },
  {
    path: "/order_can_list/",
    component: OrdersCanListPage,
    options: {
      force: true,
    },
  },
  // restaurant page
  {
    path: "/order_exp_list/",
    component: ExpiredOrderListPage,
    options: {
      force: true,
    },
  },
  {
    path: "/expiredorder/:id/",
    component: PageExpiredOrderDetailsPage,
    options: {
      force: true,
    },
  },
  // restaurant page

  {
    path: "/cancelevent/:id/",
    component: PageCanOrderDetails,
    options: {
      force: true,
    },
  },

  {
    path: "/ordersearch/",
    component: PageOrderSearch,
    options: {
      force: true,
    },
  },
  {
    path: "/addmenupopup/",
    component: AddMenuPopUp,
    options: {
      force: true,
    },
  },
  {
    name: "pay_invoice",
    path: "/pay_invoice/",
    component: PayInvoicePage,
    options: {
      force: true,
    },
  },
  {
    path: "/edit_order/:id/",
    component: EditOrderPage,
    options: {
      force: true,
    },
  },
  {
    path: "(.*)",
    component: Page404,
  },
];

export default routes;
